import { jsx } from "panel";
import { ItemsMenuEl } from "common/components/items-menu";
export function template() {
  return /* @__PURE__ */ jsx("div", null, /* @__PURE__ */ jsx(ItemsMenuEl, {
    class: { "fill-width": this.params.fillWidth },
    sel: ".target-project-menu",
    attrs: {
      sections: this.helpers.projectListSections(),
      ...this.params.projectSearchFilter && {
        "search-filter": this.params.projectSearchFilter,
        "empty-search-results-message": `No projects match your search`
      }
    },
    on: {
      clickItem: this.helpers.fireProjectSelectedEvent
    }
  }));
}
